const lastReloadStorageKey = 'staleChunkReloadAt'
const reloadCooldownMs = 10_000

/**
 * A tab opened before a deploy still lazy-loads chunks from its own build. When one of them is
 * gone, reloading picks up the new build instead of rendering the error boundary. A second failure
 * inside the cooldown is a real outage rather than a stale tab, so it is left to reach the boundary
 * instead of reloading in a loop.
 */
export const registerStaleChunkReload = () => {
  window.addEventListener('vite:preloadError', event => {
    const now = Date.now()
    if (now - getLastReloadAt() < reloadCooldownMs) {
      return
    }
    // The cooldown only holds if the timestamp survives the reload
    if (!persistReloadAt(now)) {
      return
    }
    event.preventDefault()
    window.location.reload()
  })
}

// sessionStorage directly, not storageGet/storageSet: their fallback lives on window and a reload drops it
const getLastReloadAt = () => {
  try {
    return Number(window.sessionStorage.getItem(lastReloadStorageKey) ?? 0)
  } catch {
    return 0
  }
}

const persistReloadAt = (timestamp: number) => {
  try {
    window.sessionStorage.setItem(lastReloadStorageKey, String(timestamp))
    return window.sessionStorage.getItem(lastReloadStorageKey) === String(timestamp)
  } catch {
    return false
  }
}
